<template>
  <div>
    <RmaApprovalModal
      v-if="!rmaApproved"
      :selectedRma="selectedRma"
      :returnDetails="returnDetails"
      :carrier="carrier"
      :trackingNumbers="trackingNumbers"
      :loadingReturns="loadingReturns"
      @close="$parent.close()"
      @rma:approved="$emit('rma:approved')"
      @rma:rejected="$emit('rma:rejected')"
    />
    <ReturnInspectionModal
      v-else
      :selectedRma="selectedRma"
      :returnDetails="returnDetails"
      :carrier="carrier"
      :trackingNumbers="trackingNumbers"
      :loadingReturns="loadingReturns"
      @close="$parent.close()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RmaApprovalModal from './RmaApprovalModal'
import ReturnInspectionModal from './ReturnInspectionModal'

export default {
  components: {
    RmaApprovalModal,
    ReturnInspectionModal
  },
  data () {
    return {
      loadingReturns: true,
      returnDetails: null,
      carrier: null,
      trackingNumbers: 'N/A'
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.selectedRma !== null
        ? this.context.route + '/rmas/' + this.selectedRma.id
        : null
    },
    rmaApproved () {
      return this.selectedRma.status === 'approved' && this.selectedRma.approved_at !== null
    }
  },
  methods: {
    loadReturns () {
      this.$http.get(this.endpoint + '/returns/').then(response => {
        this.returnDetails = response.data.results[0] || null
        if (this.returnDetails) {
          this.carrier = ('carrier' in this.returnDetails) ? this.returnDetails.carrier : null
        }
        const trackingNumbersList = response.data.results.map(el => el.return_tracking_number)
        if (trackingNumbersList.length > 0) {
          this.trackingNumbers = trackingNumbersList.join(',')
        }
      }).finally(() => {
        this.loadingReturns = false
      })
    }
  },
  mounted () {
    if (this.selectedRma !== null) {
      this.loadReturns()
    }
  },
  props: ['selectedRma']
}
</script>
